import { createSlice } from '@reduxjs/toolkit';
import { getCalendarPostAction, getPostDetailsAction } from '../actions';

export interface Posts {
    business_id: string;
    callToAction?: string;
    callToActionUrl?: string;
    createdAt: string;
    description: string;
    enabled: boolean;
    failureReason: string;
    images: any;
    moment: any;
    platform: string;
    platformPostId: string;
    postedAt: any;
    review: any;
    reviewType: string;
    scheduledAt: string;
    status: string;
    title: string;
    updatedAt: string;
    __v: number;
    _id: string;
    post_id?: string;
    isScheduled?: boolean;
    scheduledDateTime?: string;
    scheduled?: boolean;
    date?: string;
    reject_reason?: string;
    widgets?: string[];
    all_widgets?: boolean;
    videoGenerating?: boolean;
    yt_status?: string | null;
    audio?: string;
    visibility?: string;
    privacy_level?: string;
    privacy_level_options?: string[];
    content_type?: string;
    comment_enabled?: boolean;
    comment_disabled?: boolean;
    duet_enabled?: boolean;
    duet_disabled?: boolean;
    stitch_enabled?: boolean;
    stitch_disabled?: boolean;
    brand_content_toggle?: boolean;
    brand_organic_toggle?: boolean;
    tiktok_comment_enabled?: boolean;
    tiktok_duet_enabled?: boolean;
    tiktok_stitch_enabled?: boolean;
    tiktok_privacy_level?: string;
    tiktok_content_type?: string;
    tiktok_disable_comment?: boolean;
    tiktok_disable_duet?: boolean;
    tiktok_disable_stitch?: boolean;
    tiktok_brand_content_toggle?: boolean;
    tiktok_brand_organic_toggle?: boolean;
    auto_add_music?: boolean;
    tiktok_auto_add_music?: boolean;
    retryCount?: number;
    nextRetryAt?: string | null;
    lastRetryError?: string | null;
    failedAt?: string | null;
    failureDetail?: any;
    retry?: {
        attemptsMade?: number;
        maxAttempts?: number;
        attemptsRemaining?: number;
        willRetry?: boolean;
        nextRetryAt?: string | null;
        lastError?: string | null;
    } | null;
}
export interface IGetCalendarPostData {
    count: number;
    month: number;
    posts: Posts[];
    year: number;
}

interface WidgetState {
    getCalendarPostData: IGetCalendarPostData[] | null;
    getCalendarPostDataLoading: boolean;
    activePostData: Posts | null;
    activePostDataLoading: boolean;
}

const initialState: WidgetState = {
    getCalendarPostData: null,
    getCalendarPostDataLoading: false,
    activePostData: null,
    activePostDataLoading: false,
};


const momentSlice = createSlice({
    name: 'moment',
    initialState,
    reducers: {
        resetActivePostData: state => {
            state.activePostData = null;
            state.activePostDataLoading = false;
        }
    },
    extraReducers: builder => {
        builder

            // get calendar post
            .addCase(getCalendarPostAction.pending, state => {
                state.getCalendarPostDataLoading = true;
                state.getCalendarPostData = null;
            })
            .addCase(getCalendarPostAction.fulfilled, (state, action) => {
                state.getCalendarPostDataLoading = false;
                state.getCalendarPostData = action.payload.data;
            })
            .addCase(getCalendarPostAction.rejected, (state, action) => {
                state.getCalendarPostDataLoading = false;
                state.getCalendarPostData = action.payload as null;
            })

            // get post details
            .addCase(getPostDetailsAction.pending, state => {
                if (!state.activePostData) {
                    state.activePostDataLoading = true;
                }
            })
            .addCase(getPostDetailsAction.fulfilled, (state, action) => {
                state.activePostDataLoading = false;
                state.activePostData = action.payload.data;
            })
            .addCase(getPostDetailsAction.rejected, (state, action) => {
                state.activePostDataLoading = false;
            });
    },
});


export const { resetActivePostData } = momentSlice.actions;
export default momentSlice.reducer;